import React from "react";

import AddIcon from "@mui/icons-material/Add";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Tooltip } from "@mui/material";

import { ButtonVariant } from "Constant/button";

import StandartButton from "components/atoms/StandartButton";

import { COLORS } from "../../SignalWizard.constants";
import {
    Overline,
    PageDescription,
    PageHeader,
    PageTitle,
    wizardButtonSx,
} from "../../SignalWizard.styled";

const StepHeader = ({
    language,
    stepNumber,
    title,
    description,
    helpText,
    actionLabel,
    onAction,
    actionTestId,
}) => (
    <PageHeader>
        <div>
            <Box sx={{ mb: 1 }}>
                <Overline>
                    {language?.tracker_wizard?.step ?? "Step"} {stepNumber}{" "}
                    {language?.tracker_wizard?.of ?? "of"} 3
                </Overline>
            </Box>
            <PageTitle>{title}</PageTitle>
            <PageDescription>
                {description}
                {helpText && (
                    <Tooltip title={helpText} placement="top">
                        <HelpOutlineIcon
                            sx={{
                                ml: 0.75,
                                fontSize: 15,
                                color: COLORS.outline,
                                cursor: "help",
                                verticalAlign: "text-bottom",
                            }}
                        />
                    </Tooltip>
                )}
            </PageDescription>
        </div>
        {onAction && (
            <div>
                <StandartButton
                    variant={ButtonVariant.BLACK_OUTLINED}
                    onClick={onAction}
                    startIcon={<AddIcon />}
                    sx={wizardButtonSx}
                    data-cy={actionTestId}
                >
                    {actionLabel}
                </StandartButton>
            </div>
        )}
    </PageHeader>
);

export default StepHeader;
